module.exports = new __parcel__URL__("empty.2697b975.png").toString();